// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2E5G_","range":"MonthRangeSwitch_range__2rcp6","disabled":"MonthRangeSwitch_disabled__Do7x_"};